/* eslint-disable no-constant-condition */
import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// CUSTOM HOOKS
import useGetAllMessages from "../../../customHooks/GET_requests/useGetAllMessages";
// COMPONENTS
import GlobalAlert2 from "../../home/GlobalAlert2";
// INTERFACES
import { MessageInterface } from "../../../interfaces/Message.interface";
// CONSTANTS
import { BLANK_MESSAGE } from "../../../constants/messages";

export default function SelectMessages({
	inputValue,
	inputOnChange,
	disabledInput,
	displaySelect,
	messageType = "",
}: {
	inputValue: string;
	inputOnChange: (name: string, id: string) => void;
	disabledInput: boolean;
	displaySelect: boolean;
	messageType?: string;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const [data, setData] = useState<MessageInterface[]>([]);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { messages, isLoadingGetAllMessages, errorMessageGetAllMessages, isErrorGetAllMessages } = useGetAllMessages();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChange = (newValue: string) => {
		if (newValue) {
			const index = data.findIndex((item: any) => item.id === newValue);
			if (index >= 0) {
				inputOnChange(data[index].short_message, data[index].id);
			}
		} else {
			inputOnChange("", "");
		}
	};

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		if (messages) {
			let filteredMessages = messages;

			if (messageType) {
				const normalizedType = messageType.toUpperCase();
				filteredMessages = messages.filter(
					(msg: MessageInterface) =>
						msg.message_type?.name?.toUpperCase() === normalizedType
				);
			}

			setData([
				{
					...BLANK_MESSAGE,
				},
				...filteredMessages,
			]);
		}
	}, [messages, messageType]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className=' generalStyles__width100'>
			{displaySelect ? (
				<Select
					loading={isLoadingGetAllMessages}
					size='middle'
					className='generalStyles__width100'
					value={inputValue}
					placeholder={t("general.message")}
					onChange={onChange}
					showSearch
					optionFilterProp='label'
					filterOption={(input, option) =>
						typeof option?.label === "string" && option.label.toLowerCase().includes(input.toLowerCase())
					}
					allowClear
					disabled={disabledInput}
				>
					{data.map((item: MessageInterface) => (
						<Option key={item.id} value={item.id} label={item.short_message}>
							<span className='generalStyles__info'>
								{item && item.message_type && item.message_type.name ? item.message_type.name : ""}
							</span>
							: {item.short_message}
						</Option>
					))}
				</Select>
			) : (
				(() => {
					const selected = data.find((p: MessageInterface) => p.id === inputValue);
					return (
						<span className='generalStyles__width100'>
							{selected ? (
								<>
									<span className='generalStyles__info'>{selected?.message_type?.name || ""}</span>:{" "}
									{selected.short_message || "--"}
								</>
							) : (
								"--"
							)}
						</span>
					);
				})()
			)}
			<GlobalAlert2
				isError={isErrorGetAllMessages}
				isSuccess={false}
				requestType='GET'
				error={errorMessageGetAllMessages}
				name='Messages'
			/>
		</div>
	);
}
